import { OrderCommandService } from '../data-service/order-command.service';
import { Injectable } from '@angular/core';
import { AdditionalField } from '../models/additional-field.model';
import { AdditionalFieldHelper } from '../services/additional-field-helper.service';

@Injectable({
    providedIn: 'root'
})
export class OrderDetailsCleanUpService {

    constructor(
        private orderCommandService: OrderCommandService,
        private afdHelperService: AdditionalFieldHelper) {
    }

    async deleteAllSamples(orderCode: string) {
        await this.orderCommandService.deleteAllSamples(orderCode, 'CO2').toPromise();
    }

    async deleteOrder(orderCode: string): Promise<any> {
        return new Promise((resolve) => {
            this.orderCommandService.deleteOrder(orderCode).subscribe(data => {
                resolve(data);
            });
        });
    }

    deleteAdditionalFields(afds: string[], orderCode: string) {
        const sampleAfds: AdditionalField[] = [];
        afds.forEach(c => {
            const a = new AdditionalField();
            a.code = c;
            sampleAfds.push(a);
        });
        this.orderCommandService.deleteAfFromAllSample(orderCode, sampleAfds).subscribe();
    }

    patchSampleDetails(sampleCodes: string[], colName: string, value: string, priorVal?: string, updatePriorityValue: boolean = true) {
        this.orderCommandService.patchBulkSample(sampleCodes, colName, value, priorVal, updatePriorityValue).subscribe();
    }

    patchAdditionalFields(newAfs: AdditionalField[], orderCode: string) {
        if (newAfs.length > 0) {
            this.orderCommandService.addOptionalSamplesAf(
                orderCode,
                this.afdHelperService.buildAfDtoList(newAfs)).subscribe();
        }
    }
    async deleteSamples(orderCode: string): Promise<any> {
        return new Promise((resolve) => {
            this.orderCommandService.deleteAllSamples(orderCode, 'CO3').subscribe(() => {
                resolve(true);
            });
        });
    }

    deleteAllAnalyses(sampleCodes: string[]): Promise<any> {
        return new Promise((resolve) => {
            this.orderCommandService.removeInvoiceableItemsForSamples(sampleCodes).subscribe(() => {
                resolve(true);
            });
        });
    }

    deletePlanningLines(planningLineIds: number[]): Promise<any> {
        return new Promise((resolve) => {
            this.orderCommandService.removePlanningLines(planningLineIds).subscribe(() => {
                resolve(true);
            });
        });
    }
}
